import { gql } from "@apollo/client";
import { BundleProductFragment } from "../RootComponents/Product/BundleProductFragment.gql";

export const GET_PAGE_SIZE = gql`
  query getPageSize {
    storeConfig {
      id
      grid_per_page
    }
  }
`;

export const GET_PRODUCT_FILTERS_BY_SEARCH = gql`
  query getProductFiltersBySearch(
    $search: String!
    $filters: ProductAttributeFilterInput!
  ) {
    products(search: $search, filter: $filters) {
      aggregations {
        label
        count
        attribute_code
        options {
          label
          value
        }
      }
    }
  }
`;

export const PRODUCT_SEARCH = gql`
  query ProductSearch(
    $currentPage: Int = 1
    $inputText: String!
    $pageSize: Int = 6
    $filters: ProductAttributeFilterInput!
    $sort: ProductAttributeSortInput
  ) {
    products(
      currentPage: $currentPage
      pageSize: $pageSize
      search: $inputText
      filter: $filters
      sort: $sort
    ) {
      items {
        __typename
        categories {
          id
          uid
          breadcrumbs {
            category_id
          }
        }
        enable_site_visit
        enable_appliance_site_visit
        description {
          html
        }
        id
        uid
        type_id
        flag_text
        flag_color
        small_image {
          url
          label
        }
        simplebundle
        meta_description
        name
        unit_text
        price_range {
          minimum_price {
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
            discount {
              amount_off
              percent_off
            }
          }
          maximum_price {
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
            discount {
              amount_off
              percent_off
            }
          }
        }
        sku
        small_image {
          url
        }
        stock_status
        url_key
        ... on ConfigurableProduct {
          configurable_options {
            attribute_code
            attribute_id
            id
            label
            values {
              uid
              default_label
              label
              store_label
              use_default_value
              value_index
              swatch_data {
                ... on ImageSwatchData {
                  thumbnail
                }
                value
              }
            }
          }
          variants {
            attributes {
              code
              value_index
            }
            product {
              id
              uid
              small_image {
                url
                label
              }
              sku
              unit_text
              stock_status
              price_range {
                minimum_price {
                  regular_price {
                    value
                    currency
                  }
                  final_price {
                    value
                    currency
                  }
                  discount {
                    amount_off
                    percent_off
                  }
                }
                maximum_price {
                  regular_price {
                    value
                    currency
                  }
                  final_price {
                    value
                    currency
                  }
                  discount {
                    amount_off
                    percent_off
                  }
                }
              }
            }
          }
        }
        ... on BundleProduct {
          ...BundleProductFields
        }
      }
      page_info {
        total_pages
      }
      total_count
    }
  }
  ${BundleProductFragment}
`;

export const GET_FILTER_INPUTS = gql`
  query GetFilterInputsForSearch {
    __type(name: "ProductAttributeFilterInput") {
      inputFields {
        name
        type {
          name
        }
      }
    }
  }
`;

export default {
  getFilterInputsQuery: GET_FILTER_INPUTS,
  getPageSize: GET_PAGE_SIZE,
  getProductFiltersBySearchQuery: GET_PRODUCT_FILTERS_BY_SEARCH,
  productSearchQuery: PRODUCT_SEARCH,
};
